import http from '../../../../Service/http';
import comparator from '../../commonComparators/caseInsensitive';
import { typeToIcon, typeToColor } from './iconDefinitions';
import { projectTypeTranslationMap } from './projectTypeMapping';
import { highlightSearch } from '../../highlighters/highlightSearch';

const fetchProjectsUrl =
  '/project-store/ui/programs-and-projects?includeExposedResources=true';

const getProjectSubLabel = (project) => {
  return !project.projectType.label?.key
    ? project.projectType.label
    : project.projectType.label.key.split('.').length > 1
      ? projectTypeTranslationMap[project.projectType.label.key.split('.')[1]]
      : project.projectType.name;
};

const fetchProjects = async () => {
  const response = await http.getJSON(fetchProjectsUrl);
  return response.projects.map((project) => ({
    label: project.name,
    searchLabel: project.name,
    subLabel: getProjectSubLabel(project),
    itemId: project.id || project.url,
    projectType: project.projectType.name,
    action: () => {
      window.location.href = project.url;
    },
    icon: {
      Icon: typeToIcon(project.projectType.name),
      color: typeToColor(project.projectType.name),
    },
  }));
};

/**
 * @type {CommandPalettePlugin}
 */
export const projectPlugin = {
  getResults: async () => {
    const allProjects = await fetchProjects();

    return (searchString) =>
      Promise.resolve(
        allProjects
          .filter((project) => comparator(project.searchLabel, searchString))
          .map((project) => ({
            ...project,
            label: highlightSearch(project.label, searchString),
          })),
      );
  },
  visExp: 'true',
  id: 'projectPlugin',
};
